<script>
import draggable from "vuedraggable";
import LegoTooltip from "@/components/Lego/LegoTooltip.vue";
import CardInColumn from "@/components/Lego/CardInColumn.vue";
import CreateCard from "@/components/Lego/CreateCard.vue";
import LoadMoreColumnsBtn from "@/components/Lego/LoadMoreColumnsBtn.vue";
import LegoProgressBaWithCompleted from "@/components/Lego/LegoProgressBarWithCompleted.vue";
import LoadMoreBtn from "./LoadMoreBtn.vue";
import ZoomControls from "./ZoomControls.vue";
import ColorPicker from "./ColorPicker.vue";
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    draggable,
    LegoTooltip,
    CardInColumn,
    CreateCard,
    LegoProgressBaWithCompleted,
    LoadMoreColumnsBtn,
    LoadMoreBtn,
    ZoomControls,
    ColorPicker,
  },
  data() {
    return {
      sizesBoards: [600, 700, 300, 200, 500],
      refreshKey: 0,
      // zoomLevel: 1, // Valor inicial, se actualizará en mounted
      // minZoom: 0.5, // Zoom mínimo (50%)
      // maxZoom: 2, // Zoom máximo (200%)
      // zoomStep: 0.1, // Incremento de zoom por paso
      // zoomPosition: "right", // Valor inicial, se actualizará en mounted
    };
  },
  computed: {
    ...mapState("lego", ["board"]),
    ...mapGetters("lego", [
      "getZoomLevel",
      "getZoomPosition",
      "getZoomConfig",
      "getZoomPercentage",
    ]),
    columns() {
      if (this.board.paginatedColumns.items) {
        // Filtrar columnas que no tengan id (columnas de inicialización)
        const filteredColumns = this.board.paginatedColumns.items.filter(
          (column) => column.id !== null
        );
        return filteredColumns;
      } else {
        return [];
      }
    },
    userLoggedIn() {
      return this.$store.getters.userLoggedIn;
    },
    roleLevel() {
      return this.$store.state.lego.currencyRole.level;
    },
    hasMoreColumns() {
      return this.$store.state.lego.board.paginatedColumns.hasMore;
    },
    loadingColumns() {
      return this.$store.state.lego.loadingColumns;
    },
    isSkeleton() {
      return this.$store.state.lego.isSkeleton;
    },
    zoomStyle() {
      return {
        transform: `scale(${this.getZoomLevel})`,
        transformOrigin: "top left",
        transition: "transform 0.3s ease",
      };
    },
    // Propiedades del zoom desde el store
    zoomLevel() {
      return this.getZoomLevel;
    },
    zoomPosition() {
      return this.getZoomPosition;
    },
    zoomConfig() {
      return this.getZoomConfig;
    },
    zoomPercentage() {
      return this.getZoomPercentage;
    },
    getTasksLoading() {
      return this.$store.getters["lego/getTasksLoading"];
    },
  },
  mounted() {
    // Inicializar zoom desde el store
    this.$store.dispatch("lego/initializeZoom");
  },
  methods: {
    // Métodos de zoom usando el store
    zoomIn() {
      this.$store.dispatch("lego/zoomIn");
    },
    zoomOut() {
      this.$store.dispatch("lego/zoomOut");
    },
    resetZoom() {
      this.$store.dispatch("lego/resetZoomLevel");
    },
    setZoom(level) {
      this.$store.dispatch("lego/setZoom", level);
    },
    toggleZoomPosition() {
      this.$store.dispatch("lego/toggleZoomPosition");
    },
    async loadMoreTasksV2(paginateCards, columnId) {
      if (paginateCards.hasMore) {
        await this.$store.dispatch("lego/loadMoreTasksInColumn", {
          boardId: this.board.id,
          columnId,
          personaId: this.userLoggedIn.id,
          limit: 3,
          collaboratorRoleLevel: this.roleLevel,
          nextCursor:
            paginateCards.items.length === 0 ? null : paginateCards.nextCursor,
        });
      }
    },
    async loadMoreColumns() {
      if (this.board.paginatedColumns.hasMore) {
        await this.$store.dispatch("lego/loadMoreColumns");
      }
    },
    createColumn(column) {
      // Seria bueno agregar un loader congelando la vista hasta que se cree la columna.
      column.LegoBoardId = this.board.id;
      console.log(column);
      this.$store.dispatch("lego/addColumn", column);
    },
    setTitle(ev, column) {
      const title = ev.target.value.trim();
      if (!title) return;
      this.$store.dispatch("lego/setItemInColumn", {
        columnId: column.id,
        obj: { title },
      });
      ev.target.blur();
    },
    setColor(ev, column) {
      const color = ev.target.value.trim();
      if (!color) return;
      this.$store.dispatch("lego/setItemInColumn", {
        columnId: column.id,
        obj: { color },
      });
    },
    deleteColumn(column) {
      this.$store.dispatch("lego/deleteColumn", column);
    },
    createCard(card, column) {
      card.LegoColumnId = column.id;
      this.$store.dispatch("lego/addCard", card);
    },
    onEndColumn(ev) {
      if (this.roleLevel !== 1) return false;
      const { oldIndex, newIndex } = ev;

      let columnMove = this.columns[oldIndex];

      this.$store.dispatch("lego/moveColumn", {
        columnId: columnMove.id,
        newIndex: newIndex,
      });
    },
    onCardDrop(event) {
      const { added, moved } = event;

      let movedCard, newIndex, sourceColumnId, targetColumnId;

      if (moved) {
        movedCard = moved.element;
        newIndex = moved.newIndex;
        sourceColumnId = targetColumnId = movedCard.legoColumnId;
      } else if (added) {
        movedCard = added.element;
        newIndex = added.newIndex;

        // Encontrar columna destino por estructura actual
        targetColumnId = this.board.paginatedColumns.items.find((col) =>
          col.paginatedCards.items.some((c) => c.id === movedCard.id)
        )?.id;

        // Columna origen viene de la tarjeta
        sourceColumnId = movedCard.legoColumnId;
      } else return; // No se detectó movimiento

      if (!movedCard || !sourceColumnId || !targetColumnId) return;

      // Despachar acción para mover
      this.$store.dispatch("lego/moveCardv3", {
        cardId: movedCard.id,
        sourceColumnId,
        targetColumnId,
        newIndex,
      });
    },

    onDragStart(event, sourceColumnId) {
      const draggedCardComponent = event.item.__vue__;
      if (draggedCardComponent?.card) {
        draggedCardComponent.card._dragSourceColumnId = sourceColumnId;
      }
    },
    onMove() {
      return this.roleLevel === 1;
    },
  },
};
</script>

<template>
  <div class="kanban-container">
    <!-- Contenedor del tablero -->
    <div class="board-container">
      <div class="board" id="tablerosKanban">
        <div class="board-content" :style="zoomStyle">
          <draggable
            class="wrapper-columns"
            :group="{ name: 'columns' }"
            animation="300"
            :columns="columns"
            @end="onEndColumn"
            handle=".drag-handle"
            :move="onMove"
          >
            <div
              :style="{ boxShadow: '0 2px 4px rgba(0, 0, 0, 0.08)' }"
              v-show="!isSkeleton"
              v-for="(column, index) in columns"
              :key="column.id"
              :id="column.id"
              class="column-wrapper"
            >
              <div
                :style="{ borderTop: '4px solid ' + column.color }"
                class="column drag-handle"
              >
                <header :id="'headerTablero' + index">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div class="d-flex align-items-center" style="gap: 0.5rem">
                      <!-- Indicador de arrastre para columnas -->
                      <div v-if="roleLevel === 1" class="column-drag-indicator">
                        <i class="fas fa-grip-vertical"></i>
                      </div>
                      <div class="tasks-indicator">
                        <span
                          v-if="
                            column.paginatedCards.items.length &&
                            column.paginatedCards.total
                          "
                          v-b-tooltip.hover
                          :title="`${column.paginatedCards.items.length} de ${column.paginatedCards.total} tareas`"
                        >
                          {{ column.paginatedCards.items.length }}/{{
                            column.paginatedCards.total
                          }}
                        </span>
                        <span v-else> </span>
                      </div>
                    </div>
                    <div class="column-controls">
                      <!-- * control column -->
                      <LegoTooltip v-if="roleLevel === 1" position="bottom">
                        <template #button>
                          <div class="color-picker-trigger">
                            <i class="fas fa-palette"></i>
                          </div>
                        </template>
                        <div class="wrapper-color">
                          <ColorPicker
                            :value="column.color"
                            :key="column.id + '-color'"
                            @input="
                              (color) =>
                                setColor({ target: { value: color } }, column)
                            "
                          />
                        </div>
                      </LegoTooltip>

                      <!-- Botón eliminar columna separado -->
                      <LegoTooltip v-if="roleLevel === 1" position="bottom">
                        <span
                          class="text-lego-danger"
                          @click="deleteColumn(column)"
                          >Eliminar columna</span
                        >
                      </LegoTooltip>
                    </div>
                  </div>
                  <input
                    v-b-tooltip.hover
                    :title="column.title"
                    class="column-title"
                    type="text"
                    :value="column.title"
                    @keydown.enter="setTitle($event, column)"
                    @blur="setTitle($event, column)"
                  />
                </header>
                <!-- progreso de columna -->
                <LegoProgressBaWithCompleted
                  :total="column.paginatedCards.total"
                  :completed="column.paginatedCards.completed"
                  position="left"
                  size="sm"
                  mode="cards"
                  :id="'progresoTareaTablero' + index"
                />
                <CreateCard
                  @createCard="createCard($event, column)"
                  v-if="roleLevel < 3"
                  :id="'crearTarjeta' + index"
                />
                <div class="tasks-container">
                  <draggable
                    class="wrapper-tasks"
                    ghost-class="bg-blue-200"
                    :list="column.paginatedCards.items"
                    :group="{ name: 'cards' }"
                    :item-key="'id'"
                    animation="300"
                    @change="onCardDrop($event)"
                    @start="onDragStart($event, column.id)"
                    :move="onMove"
                  >
                    <CardInColumn
                      v-for="(card, index) in column.paginatedCards.items"
                      :key="card.id"
                      :card="card"
                      :id="'cardInColumn' + index"
                    />
                  </draggable>
                </div>

                <div
                  v-show="column.paginatedCards.items.length >= 3"
                  class="tasks-indicator text-right"
                  v-b-tooltip.hover
                  :title="`${column.paginatedCards.items.length} de ${column.paginatedCards.total} tareas`"
                >
                  {{ column.paginatedCards.items.length }}/{{
                    column.paginatedCards.total
                  }}
                </div>

                <!-- cargar mas tareas -->
                <LoadMoreBtn
                  @loadMore="loadMoreTasksV2(column.paginatedCards, column.id)"
                  :loading="getTasksLoading(column.id)"
                  v-if="column.paginatedCards.hasMore"
                />
              </div>
            </div>
            <b-skeleton
              v-show="isSkeleton"
              v-for="column in 5"
              :key="column"
              width="300px"
              :height="`${sizesBoards[column - 1]}px`"
            ></b-skeleton>
          </draggable>

          <!-- cargar mas columnas - Mantiene posición original -->
          <LoadMoreColumnsBtn
            @loadMoreColumns="loadMoreColumns"
            :loading="loadingColumns"
            v-if="hasMoreColumns && !isSkeleton && columns.length > 0"
          />
        </div>
      </div>
    </div>

    <!-- Controles de zoom -->
    <ZoomControls
      :zoomLevel="zoomLevel"
      :minZoom="zoomConfig.minZoom"
      :maxZoom="zoomConfig.maxZoom"
      :zoomStep="zoomConfig.zoomStep"
      :zoomPosition="zoomPosition"
      @zoom-in="zoomIn"
      @zoom-out="zoomOut"
      @reset-zoom="resetZoom"
      @set-zoom="setZoom"
      @toggle-position="toggleZoomPosition"
    />
  </div>
</template>

<style scoped>
/* Contenedor principal */
.kanban-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

/* Contenedor del tablero */
.board-container {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 20px;
}

.tasks-indicator {
  opacity: 0.7;
}

.board {
  padding: 1rem;
  overflow: scroll;
  width: 100%;
  height: 100%;
  display: flex;
  gap: 0.5rem;
  position: relative;
}

/* Contenedor del contenido con zoom */
.board-content {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  transform-origin: top left;
  transition: transform 0.3s ease;
  will-change: transform;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
}

.wrapper-columns {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
}

.column-wrapper {
  border-radius: 12px;
}

.column {
  position: relative;
  padding: 0.5rem;
  width: 300px;
  border-radius: 12px;
  cursor: move;
  /* box-shadow: inset 0 4px 0 0 var(--lego-dbg); */
  background-color: var(--lego-dbg);
}

.column-title {
  background-color: transparent;
  letter-spacing: 0.25rem;
  border: 0;
  outline: none;
  font-weight: normal;
  cursor: pointer;
  transition: 0.3s;
  color: white;
  padding: 0.5rem;
  border-radius: 3px;
  width: 100%;
  box-sizing: border-box;
}

.column-title:focus {
  background-color: var(--lego-light-hover);
  cursor: text;
}

.tasks-container {
  position: relative;
}

.wrapper-tasks {
  /* border-top: 0.25rem solid; */
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.column-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.wrapper-color {
  padding: 0;
  position: relative;
}

.color-picker-trigger {
  background: transparent;
  border: none;
  color: var(--text-progress);
  cursor: pointer;
  padding: 6px;
  border-radius: 4px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.3;
}

.color-picker-trigger:hover {
  background: var(--lego-light-hover);
  transform: scale(1.1);
  opacity: 0.7;
}

.color-picker-trigger i {
  font-size: 14px;
}

.dark .color-picker-trigger {
  color: var(--text-progress);
}

.dark .color-picker-trigger:hover {
  background: var(--lego-dark-hover);
}

/* Indicador de arrastre para columnas */
.column-drag-indicator {
  opacity: 0.3;
  transition: opacity 0.2s ease;
  color: var(--text-progress);
  margin-left: 0.5rem;
  cursor: grab;
}

.column:hover .column-drag-indicator {
  opacity: 0.7;
}

.dark .column-drag-indicator {
  color: var(--text-progress);
}
</style>
